import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from './media/logo-transparent.png';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const close = () => setMenuOpen(false);

    return (
        <nav className="navbar">
            <div className="logo">
                <Link to="/" onClick={close}>
                    <img src={logo} width={72} height={72} alt="Afrika-Link e.V." />
                </Link>
            </div>
            <button
                className={`hamburger${menuOpen ? ' open' : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Menü öffnen"
                aria-expanded={menuOpen}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className={`nav-items${menuOpen ? ' open' : ''}`}>
                <Link className="nav-link" to="/" onClick={close}>Home</Link>
                <Link className="nav-link" to="/projekte" onClick={close}>Projekte</Link>
                <Link className="nav-link" to="/veranstaltungen" onClick={close}>Veranstaltungen</Link>
                <Link className="nav-link" to="/agri-connect" onClick={close}>Agri-Connect</Link>
                <Link className="nav-link" to="/presse" onClick={close}>Presse</Link>
                <Link className="nav-link" to="/about" onClick={close}>Über uns</Link>
            </div>
        </nav>
    );
};

export default Navbar;
